import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Snackbar from 'components/Snackbars/Snackbar';
import Box from '@mui/material/Box';
import { closeError } from 'actions/error';
import { styled } from '@mui/system';

const BoxStyled = styled(Box)(({ theme }) => ({
  borderRadius: 0,
  right: 22,
  bottom: 22,
  position: 'fixed',
  zIndex: 5000,
  maxWidth: 350,
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    left: 0,
    right: 0,
    bottom: 0,
    maxWidth: '100%',
    width: '100%',
    padding: '0 16px 16px 16px',
    boxSizing: 'border-box',
    overflow: 'hidden'
  }
}));

const SnackbarWrapper = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const errors = useSelector((state) => state?.error?.list || []);

  const handleClose = React.useCallback(
    (errorIndex) => dispatch(closeError(errorIndex)),
    [dispatch]
  );

  const isAssessmentRoute = /(^|\/)assessment(\/|$)/.test(location.pathname);
  const isProRoute = /(^|\/)pro\/?$/.test(location.pathname);
  const isPolicyRoute = /(^|\/)policy(\/|$)/.test(location.pathname);
  const hideGamification = isAssessmentRoute || isProRoute || isPolicyRoute;

  const visibleErrors = (errors || []).map((error, index) => ({ error, index }))
    .filter(({ error }) => !(hideGamification && error?.variant === 'dailyQuest'));

  return (
    <BoxStyled>
      {visibleErrors.map(({ error, index }) => (
        <Snackbar key={index} error={error} onClose={(e) => handleClose(index)} />
      ))}
    </BoxStyled>
  );
};

export default SnackbarWrapper;
